import { render, staticRenderFns } from "./FilterBtn.vue?vue&type=template&id=50540566"
import script from "./FilterBtn.vue?vue&type=script&lang=js"
export * from "./FilterBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports